module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/th_1-27cacc980f2d1a7ec61b0e7dc3ad25c2.jpg";